<template>
  <span>
    Сайт использует сервис Google ReCAPTCHA:
    <a
      href="https://policies.google.com/privacy?hl=ru"
      target="_blank"
      rel="noopener"
    >
      Конфиденциальность
    </a>
    и
    <a
      href="https://policies.google.com/terms?hl=ru"
      target="_blank"
      rel="noopener"
    >
      Условия использования
    </a>
  </span>
</template>
